var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeldBoxLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 76H17.5882L24.2497 102.26L32.6394 76H41.8931L50.2828 102.317L56.8607 76H66.0866L55.0769 117H45.7674L37.1548 89.8079L28.4864 117H19.0097L8 76Z",
    fill: "#21211E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0716 117V76H100.687V84.6123H84.0744V92.4339H100.687V100.453H84.0744V108.331H100.742V117H75.0716Z",
    fill: "#21211E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.347 117V76H121.35V108.275H138.826V117H112.347Z",
    fill: "#21211E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.675 117V76H162.681C168.813 76 173.728 77.8542 177.425 81.5627C181.142 85.2523 183 90.2408 183 96.5282C183 102.816 181.142 107.804 177.425 111.494C173.709 115.165 168.776 117 162.625 117H148.675ZM157.678 108.388H162.291C163.87 108.388 165.329 108.152 166.667 107.682C168.023 107.211 169.222 106.505 170.262 105.564C171.303 104.623 172.111 103.38 172.687 101.837C173.282 100.293 173.579 98.5236 173.579 96.5282C173.579 94.5328 173.282 92.7633 172.687 91.2197C172.111 89.6761 171.303 88.4337 170.262 87.4924C169.222 86.5324 168.023 85.817 166.667 85.3464C165.329 84.857 163.87 84.6123 162.291 84.6123H157.678V108.388Z",
    fill: "#21211E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeldBoxLight);
export default __webpack_public_path__ + "static/media/weld_box_light.4537c3e61ca1c4cec4b16282f18a5ea8.svg";
export { ForwardRef as ReactComponent };